import React from 'react';
import CompactPropertyCard from '../../../components/property/property-card/CompactPropertyCard';
import { Listing } from '../../../components/property/property-card/PropertyCardTypes';

interface MobilePropertyGridProps {
  listings: Listing[];
  bookmarkedListings: number[];
  onBookmarkToggle: (id: number) => void;
  onListingView: (listing: Listing) => void;
}

/**
 * Mobile-optimized property grid with compact cards
 * Uses a 2-column grid layout on mobile similar to Airbnb mobile
 */
const MobilePropertyGrid: React.FC<MobilePropertyGridProps> = ({
  listings,
  bookmarkedListings,
  onBookmarkToggle,
  onListingView
}) => {
  return (
    <div className="grid grid-cols-2 gap-3 pb-4">
      {listings.map((listing, index) => (
        <div key={listing.id} onMouseEnter={() => onListingView(listing)}>
          <CompactPropertyCard
            listing={listing}
            isBookmarked={bookmarkedListings.includes(listing.id)}
            onBookmarkToggle={onBookmarkToggle}
            isTopViewed={index < 3}
          />
        </div>
      ))}
    </div>
  );
};

export default MobilePropertyGrid;
